var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFileUpload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.6666 4.66602L46.6666 18.666V46.666C46.6666 47.9037 46.1749 49.0907 45.2998 49.9658C44.4246 50.841 43.2376 51.3327 41.9999 51.3327H13.9999C12.7622 51.3327 11.5753 50.841 10.7001 49.9658C9.82492 49.0907 9.33325 47.9037 9.33325 46.666V9.33268C9.33325 8.09501 9.82492 6.90802 10.7001 6.03285C11.5753 5.15768 12.7622 4.66602 13.9999 4.66602H32.6666ZM41.9999 46.666V20.9993H30.3333V9.33268H13.9999V46.666H41.9999ZM27.9999 27.9993L37.3333 37.3327H31.4999V44.3327H24.4999V37.3327H18.6666L27.9999 27.9993Z",
    fill: "#243D7F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileUpload);
export default __webpack_public_path__ + "static/media/file-upload.2bbbb348c989dd957b51aff447833b7f.svg";
export { ForwardRef as ReactComponent };